<ng-container [ngSwitch]="typeOfUser">

    <ng-template [ngSwitchCase]="usersGroup.admin">
        <app-dashboard-admin></app-dashboard-admin>
    </ng-template>

    <ng-template [ngSwitchCase]="usersGroup.companyManager">
        <app-dashboard-company></app-dashboard-company>
    </ng-template>

    <ng-template [ngSwitchCase]="usersGroup.user">
        <app-dashboard-athlete></app-dashboard-athlete>
    </ng-template>

    <ng-template [ngSwitchCase]="usersGroup.agent">
        <app-dashboard-agent></app-dashboard-agent>
    </ng-template>

    <!-- Placeholder dashboard for mister/coach (dedicated screens can be added later) -->
    <ng-template [ngSwitchCase]="usersGroup.mister">
        <app-dashboard-mister></app-dashboard-mister>
    </ng-template>

    <ng-template *ngSwitchDefault>
        User type not valid
    </ng-template>
</ng-container>
